import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 55"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#BFBFBF\" d=\"M37.167 13.75h-4.584v9.167h-9.166V13.75h-4.584L27.99 2.303 28 2.292z\"></path><path fill=\"#BFBFBF\" d=\"M23.417 22.917v9.166H14.25v4.584L2.803 27.51l-.011-.011 11.458-9.167v4.584zM53.209 27.5l-.012.011-11.447 9.156v-4.584h-9.166v-9.166h9.166v-4.584zM37.167 41.25 28 52.708l-.011-.011-9.155-11.447h4.583v-9.167h9.167v9.167z\"></path><path fill=\"#093\" d=\"M14.25 13.75v27.5h27.5v-27.5zm18.333 18.333h-9.166v-9.166h9.166z\"></path><path fill=\"#0A0B0D\" d=\"M32.583 13.75h-9.166v9.167h9.166zM23.417 22.917H14.25v9.166h9.167zM41.75 22.917h-9.166v9.166h9.166zM32.583 32.083h-9.166v9.167h9.166z\"></path><path fill=\"#0A0B0D\" d=\"M32.583 13.75h-9.166v9.167h9.166zM23.417 22.917H14.25v9.166h9.167zM32.583 32.083h-9.166v9.167h9.166zM41.75 22.917h-9.166v9.166h9.166z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }